var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": function ($event) {
        return _vm.changeToShow(false);
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Ajouter un nouveau dossier")]), _vm._v(" "), _c('form', {
    staticClass: "flex flex-col items-center mb-5",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('input-text', {
    staticClass: "lg:w-1/2 mb-5",
    attrs: {
      "name": "folderName",
      "libelle": "Nom du dossier",
      "value": _vm.newFolder.name,
      "error": true,
      "msg-error": ((_vm.errors || []).name || [])[0],
      "maxlength": 40
    },
    on: {
      "input": function (newValue) {
        _vm.newFolder.name = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "min-w-max"
  }, [_c('div', {
    staticClass: "text-sm text-gray-600 mb-2"
  }, [_vm._v("Couleur du dossier")]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-7"
  }, _vm._l(_vm.colors, function (color, index) {
    return _c('div', {
      key: index,
      class: 'flex items-center justify-center transition ease-in-out duration-300 transform hover:scale-110 cursor-pointer border rounded-md w-8 h-8 ' + color.border + ' ' + color.bg,
      on: {
        "click": function ($event) {
          return _vm.selectColor(index);
        }
      }
    }, [color.name == _vm.newFolder.color ? _c('icon', {
      class: color.checkmark + ' h-3 w-3',
      attrs: {
        "name": "checkmark"
      }
    }) : _vm._e()], 1);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "text-red-500 text-sm mt-2"
  }, [_vm._v("\n                        " + _vm._s(((_vm.errors || []).color || [])[0]) + "\n                    ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-red-500 text-sm mb-10 text-center"
  }, [_vm._v("\n                " + _vm._s(((_vm.errors || []).folders || [])[0]) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": _vm.saving ? 'bg-gray-600' : 'bg-pink-600',
      "bg-color-square": _vm.saving ? 'bg-gray-600' : 'bg-pink-600',
      "icon-color": "text-white",
      "libelle": "AJOUTER",
      "type-shadow": _vm.saving ? 'shadow-gray' : 'shadow-pink'
    },
    on: {
      "clickAction": function ($event) {
        !_vm.saving ? _vm.createNewFolder() : null;
      }
    }
  })], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }